export enum DashboardActionTypes {
  GET_TOP5_COMPUTERS = "GET_TOP5_COMPUTERS",
  GET_TOP5_GROUPS = "GET_TOP5_GROUPS",
  GET_EVENT_TRENDS = "GET_EVENT_TRENDS",
  GET_TOP_COMPUTERS = "GET_TOP_COMPUTERS",
  GET_BLOCKS_OVERTIME = "GET_BLOCKS_OVERTIME",
  GET_ALERT_SUMMARY = "GET_ALERT_SUMMARY",
  GET_COMPANY_OVERVIEW = "GET_COMPANY_OVERVIEW",
  GET_KNOWN_THREADS = "GET_KNOWN_THREADS",
  GET_NUMBER_OF_BLOCKS_BY_TIME = "GET_NUMBER_OF_BLOCKS_BY_TIME"
}
